/* eslint-disable react/no-children-prop */
import React from "react";
import { Wrapper } from "./styled";

const Cell = ({ show, value }) => {
  if (!show) {
    return null;
  }

  return <Wrapper children={value} />;
};

export default Cell;
